import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderTwo } from 'secondstep-components'
import AdminExportDownloadButton from 'components/AdminExportDownloadButton'
import InterventionsSubheader from 'components/admin/Interventions/Subheader'

const breakpoints = {
  customTablet: '@media screen and (max-width: 860px)',
}

export const K8Tier2ViewContainer = styled.div`
  background-color: ${themeGet('colors.white')};
  padding: 1.5625rem 1.25rem;
  border-radius: 0.625rem;
  position: relative;
`

export const LastUpdatedAtText = styled.span`
  position: relative;
  top: -0.625rem;
  color: ${themeGet('colors.gray1100')};
  font-size: 0.75rem;

  ${breakpoints.customTablet} {
    display: none;
  }
`

export const LeftBox = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoints.customTablet} {
    margin-bottom: 0.4375rem;
  }
`

export const LoadingMessage = styled.div`
  margin-top: 1rem;
`

export const SiteHeader = styled.div`
  margin-bottom: 0;
`

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${breakpoints.customTablet} {
    flex-direction: column;
  }
`

export const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 0.375rem;

  ${breakpoints.customTablet} {
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 0.375rem;
  }
`

export const StyledAdminExportDownloadButton = styled(
  AdminExportDownloadButton,
)`
  flex-shrink: 0;
`

export const StyledInterventionsSubheader = styled(InterventionsSubheader)`
  > div {
    margin: 0;
  }
`

export const TierPill = styled.div`
  margin: 0 0 0.6875rem 1.125rem;

  span {
    background: ${themeGet('colors.aliceBlue')};
    color: ${themeGet('colors.darkGray')};
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    padding: 0.375rem 1rem 0.25rem;
    border-radius: 6.25rem;
  }
`

export const Title = styled(HeaderTwo)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`
